module.exports = __webpack_public_path__ + "static/quasar-pratus-logo-e0e65b9b414c23e356ca02911677f9cb.png";